{
    "name": "j",
    "actionTrace": [
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "hero",
            "position": {
                "x": 15,
                "y": 13,
                "z": 1
            },
            "performerPosition": {
                "x": 15,
                "y": 14,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "princess",
            "position": {
                "x": 15,
                "y": 14,
                "z": 1
            },
            "performerPosition": {
                "x": 15,
                "y": 15,
                "z": 1
            }
        }
    ],
    "deltastageSum": {
        "units": {
            "princess": {
                "key": "princess",
                "jobKey": "sword",
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 50,
                "moverange": 2,
                "skills": [
                    "inflict-damage",
                    "rally",
                    "recruit"
                ],
                "name": "PRINCESS",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "portraits": {
                    "neutral": "./RP-neutral2-ZK5JV6ZJ.png",
                    "angry": "./RP-angry-AJ6PJQEY.png",
                    "happy": "./RP-happy-HEYINXAH.png"
                },
                "position": {
                    "mode": "absolute",
                    "x": 15,
                    "y": 15,
                    "z": 1
                },
                "spawnspot": {
                    "position": {
                        "x": 14,
                        "y": 15,
                        "z": 1
                    },
                    "key": "gEJIW",
                    "tag": "spawn"
                },
                "experience": 10,
                "energy": {
                    "key": "princess",
                    "energy": {
                        "move": false,
                        "invoke skill": false
                    }
                }
            },
            "hero": {
                "key": "hero",
                "jobKey": "hammer",
                "aliases": [
                    "Himmel",
                    "paladin",
                    "Masked Man"
                ],
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 50,
                "skills": [
                    "inflict-damage",
                    "smite",
                    "recruit"
                ],
                "name": "HERO",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "position": {
                    "mode": "absolute",
                    "x": 15,
                    "y": 14,
                    "z": 1
                },
                "spawnspot": {
                    "position": {
                        "x": 16,
                        "y": 15,
                        "z": 1
                    },
                    "key": "7sJFA",
                    "tag": "spawn"
                },
                "experience": 10,
                "energy": {
                    "key": {
                        "0": "h",
                        "1": "e",
                        "2": "r",
                        "3": "o"
                    },
                    "energy": {
                        "move": true,
                        "invoke skill": true
                    }
                }
            },
            "tJAOh": {
                "key": "tJAOh",
                "health": 30,
                "position": {
                    "mode": "absolute",
                    "x": 15,
                    "y": 13,
                    "z": 1
                },
                "state": "aggroed"
            }
        },
        "dialogue": {},
        "audio": {
            "triggerKey": "Unit:Attack"
        },
        "type": "particle",
        "text": {
            "string": "-20",
            "font": "numbers"
        },
        "opacity": 0,
        "flags": {
            "tutorial:hasAttacked": true,
            "tutorial:hasAttackedWithoutCounterattack": true,
            "tutorial:AttackerColor": "green",
            "tutorial:hasRallied": true
        }
    },
    "sequenceLengthRemaining": 0,
    "chapterSlug": "demo",
    "player": {
        "affiliation": "good",
        "inventory": {
            "gold": 0
        },
        "party": {
            "units": {
                "princess": {
                    "key": "princess",
                    "jobKey": "sword",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 50,
                    "moverange": 2,
                    "skills": [
                        "inflict-damage",
                        "rally",
                        "recruit"
                    ],
                    "name": "PRINCESS",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    },
                    "portraits": {
                        "neutral": "./RP-neutral2-ZK5JV6ZJ.png",
                        "angry": "./RP-angry-AJ6PJQEY.png",
                        "happy": "./RP-happy-HEYINXAH.png"
                    }
                },
                "hero": {
                    "key": "hero",
                    "jobKey": "hammer",
                    "aliases": [
                        "Himmel",
                        "paladin",
                        "Masked Man"
                    ],
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 50,
                    "skills": [
                        "inflict-damage",
                        "smite",
                        "recruit"
                    ],
                    "name": "HERO",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                },
                "friend": {
                    "key": "friend",
                    "jobKey": "bow",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 40,
                    "skills": [
                        "inflict-damage",
                        "pull",
                        "recruit"
                    ],
                    "name": "FRIEND",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                },
                "aide": {
                    "key": "aide",
                    "jobKey": "dagger",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 40,
                    "skills": [
                        "inflict-damage",
                        "swap",
                        "recruit"
                    ],
                    "name": "AIDE",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                }
            }
        }
    },
    "gameSlug": "war",
    "randomSeed": "xuiwk3L9P2EbfSrTN_ATL",
    "captureDate": 1738091487586,
    "data": {}
}